import { render, staticRenderFns } from "./NewUpgrade.vue?vue&type=template&id=636ca933&"
import script from "./NewUpgrade.vue?vue&type=script&lang=js&"
export * from "./NewUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./NewUpgrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports